module.exports = __webpack_public_path__ + "media/images/office-3-df0d8fb3.jpg";